import { EFacilityType, JsonQuery } from '@/packages/JsonQuery';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagFacilitiesSchema } from '../types';

const TEXT_MAP: { [key in EFacilityType]: string } = {
  [EFacilityType.Bath]: 'С ванной',
  [EFacilityType.Conditioner]: 'С кондиционером',
  [EFacilityType.Fridge]: 'С холодильником',
  [EFacilityType.Garage]: 'С гаражом',
  [EFacilityType.Internet]: 'С интернетом',
  [EFacilityType.Phone]: 'С телефоном',
  [EFacilityType.Pool]: 'С бассейном',
  [EFacilityType.Sauna]: 'С баней',
  [EFacilityType.Security]: 'С охраной',
  [EFacilityType.Shower]: 'С душевой кабиной',
  [EFacilityType.TV]: 'С телевизором',
  [EFacilityType.Washer]: 'Со стиральной машиной',
  [EFacilityType.Dishwasher]: 'С посудомоечной машиной',
  [EFacilityType.WithoutFurniture]: 'Без мебели',
  [EFacilityType.RoomFurniture]: 'Комнатная мебель',
  [EFacilityType.KitchenFurniture]: 'С кухонной мебелью',
  [EFacilityType.KidsAllowed]: 'Можно с детьми',
  [EFacilityType.PetsAllowed]: 'Можно с животными',
};

export const facilities: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = new JsonQuery(jsonQuery).getAllFacilities() || [];

    const tagsGroup: TagFacilitiesSchema[] = value.map(key => ({
      group: 'facilities',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagFacilitiesSchema) {
    const currentValue = new JsonQuery(jsonQuery).getAllFacilities() || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setAllFacilityTypes',
      arguments: [nextValue],
    });
  },
};
